import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.CompanyInfoPage.AdditionalServiceCardDext', {
    dextPrepare: 'Dext Prepare',
    connect: 'Connect',
    showActionMenu: 'Show action menu',
    disconnect: 'Disconnect',
    reconnect: 'Reconnect',
    connectedDescription:
        'Your Dext Prepare account is connected - you can receive, review and approve captured Bills in ApprovalMax before publishing them to {integrationName}.',
    disconnectedDescription:
        'Connect your Dext Prepare account to enable the receiving, review and approval of captured Bills in ApprovalMax before they are published to {integrationName}.',
    learnMore: 'Learn more',
    gotoWorkflows: 'Go to workflows',
    labelConnected: 'Connected',
    warningConnectDisabled: 'Please enable {integrationName} integration to connect your Dext Prepare account',
});
